import React from 'react'
import { VOICE_OPTIONS } from '../../services/constants'

/**
 * 음성 설정 컴포넌트
 */
function VoiceSettings({ selectedVoice, setSelectedVoice }) {
  // 기존 로직에 맞춰 value만 현재 사용 중인 값으로 맞춰주세요.
  const OPTIONS = [
    { value: "male", label: "남성" },
    { value: "female", label: "여성" },
  ];

  // 키보드 접근성: 좌/우 화살표로 전환
  const onKeyDown = (e) => {
    const idx = OPTIONS.findIndex((o) => o.value === selectedVoice);
    if (idx === -1) return;
    if (e.key === "ArrowRight") {
      const next = OPTIONS[(idx + 1) % OPTIONS.length];
      setSelectedVoice(next.value);
      e.preventDefault();
    } else if (e.key === "ArrowLeft") {
      const prev = OPTIONS[(idx - 1 + OPTIONS.length) % OPTIONS.length];
      setSelectedVoice(prev.value);
      e.preventDefault();
    }
  };

  return (
    <div className="sidebar-section voice-settings">
      {/* 제목과 토글을 한 줄로 배치 */}
      <label className="voice-label" id="voiceSettingsLabel">
        음성 설정
      </label>

      {/* (1) 숨겨진 native select: 기존 폼/통합 로직 유지용 */}
      <select
        value={selectedVoice}
        onChange={(e) => setSelectedVoice(e.target.value)}
        className="visually-hidden"
        aria-hidden="true"
        tabIndex={-1}
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      {/* (2) 보이는 토글 UI (라디오 그룹 역할) */}
      <div
        className="toggle-group"
        role="radiogroup"
        aria-labelledby="voiceSettingsLabel"
        onKeyDown={onKeyDown}
      >
        {OPTIONS.map((o) => {
          const checked = selectedVoice === o.value;
          return (
            <button
              key={o.value}
              type="button"
              role="radio"
              aria-checked={checked}
              className={`toggle-btn ${checked ? "is-active" : ""}`}
              onClick={() => setSelectedVoice(o.value)}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default VoiceSettings